import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_available_inventory_by_lotIds_packagedIds_warehouseIds_batchedService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lotIds: number[], packagedIds: number[], warehouseIds: number[] }): 
  Promise<{ result: { TotalAvailableAmount?: number, LotId?: number, PackagedId?: number, Warehouse?: { Id?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lotIds)) {
      $missingRequiredInParams.push('\'lotIds\'');
    }
    if (isNil($inParams.packagedIds)) {
      $missingRequiredInParams.push('\'packagedIds\'');
    }
    if (isNil($inParams.warehouseIds)) {
      $missingRequiredInParams.push('\'warehouseIds\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { lotIds: number[], packagedIds: number[], warehouseIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { TotalAvailableAmount?: number, LotId?: number, PackagedId?: number, Warehouse?: { Id?: number } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lotIds)) {
      $missingRequiredInParams.push('\'lotIds\'');
    }
    if (isNil($inParams.packagedIds)) {
      $missingRequiredInParams.push('\'packagedIds\'');
    }
    if (isNil($inParams.warehouseIds)) {
      $missingRequiredInParams.push('\'warehouseIds\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { lotIds: number[], packagedIds: number[], warehouseIds: number[], $keys: { LotId?: number, PackagedId?: number, Warehouse?: { Id?: number } }[] }): 
  Promise<{ result: { TotalAvailableAmount?: number, LotId?: number, PackagedId?: number, Warehouse?: { Id?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lotIds)) {
      $missingRequiredInParams.push('\'lotIds\'');
    }
    if (isNil($inParams.packagedIds)) {
      $missingRequiredInParams.push('\'packagedIds\'');
    }
    if (isNil($inParams.warehouseIds)) {
      $missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lotIds: number[], packagedIds: number[], warehouseIds: number[]    }) {
        if(isNil($inParams.lotIds)) {
          return true; 
        }
        if(isNil($inParams.packagedIds)) {
          return true; 
        }
        if(isNil($inParams.warehouseIds)) {
          return true; 
        }
      return false;
    }
}
